import { usePalletsTypes } from 'constants/palletTypes';
import { Balance } from 'interfaces';

import { sortOptions } from './sortOptions';

export const getPalletTypesOptionsFromStorageBalance = (
   storageBalance: Balance,
   PALLET_TYPES_LABELS_WITH_DIMENSIONS: ReturnType<
      typeof usePalletsTypes
   >['PALLET_TYPES_LABELS_WITH_DIMENSIONS'],
) => {
   const paletteTypesOptions = Object.keys(storageBalance).map(palletType => ({
      label: PALLET_TYPES_LABELS_WITH_DIMENSIONS[
         palletType as keyof typeof PALLET_TYPES_LABELS_WITH_DIMENSIONS
      ].label,
      value: palletType,
   }));
   return sortOptions(paletteTypesOptions);
};
